export const Options = {
  // 证件类型
  id_type: [
    { label: '身份证', value: '01' },
    // { label: '港澳台回乡证', value: '09' },
    { label: '护照', value: '51' },
    { label: '港澳居民来往内地通行证', value: '09' },
    { label: '台湾居民来往大陆通行证', value: '02' },
    { label: '港澳居民居住证', value: '03' },
    { label: '台湾居民居住证', value: '04' }
  ],
  family_card_type: [
    { label: '身份证', value: '1' },
      { label: '护照', value: '2' },
      { label: '军官证', value: '3' },
      { label: '士兵证', value: '4' },
      { label: '港澳居民往来内地通行证', value: '5' },
      { label: '台湾居民来往大陆通行证', value: '6' },
      { label: '户口本', value: '7' },
      { label: '出生证', value: '8' },
      { label: '港澳居民居住证', value: '10' },
      { label: '台湾居民居住证', value: '11' }
  ],
  // 婚姻状况
  marital_status: [
    { label: '未婚', value: '1' },
    { label: '已婚', value: '2' },
    { label: '离异', value: '3' },
    { label: '丧偶', value: '4' },
  ],
  // 招募来源
  recruit_source: [
    { label: '红海', value: '1' },
    { label: '蓝海', value: '2' }
  ],
  // 学位
  degree_type: [
    { label: '初中',value: '初中' },
    { label: '中专', value: '中专' },
    { label: '高中', value: '高中' },
    { label: '大专', value: '大专' },
    { label: '大学本科', value: '大学本科' },
    { label: '研究生', value: '研究生' },
    { label: '博士', value: '博士' },

  ],
  // 学历
  education: [
    { label: '初中',value: '1' },
    { label: '中专', value: '2' },
    { label: '高中', value: '3' },
    { label: '大专', value: '4' },
    { label: '大学本科', value: '5' },
    { label: '研究生', value: '6' },
    { label: '博士', value: '7' },

  ],
  // 离职原因
  reasonOfDesertJobs: [
    { text: '原公司架构调整', value: '原公司架构调整' },
    { text: '薪水问题', value: '薪水问题' },
    { text: '工作内容与职业规划不符', value: '工作内容与职业规划不符' },
    { text: '照顾家庭', value: '照顾家庭' },
    { text: '交通不便', value: '交通不便' },
    { text: '身体原因', value: '身体原因' },
    { text: '追求较为弹性大的工作状态', value: '追求较为弹性大的工作状态' },
    { text: '其他', value: '其他' },
  ],
  // 关系,
  family_relation:  [
    { label: '父母', value: '0' },
    { label: '配偶', value: '1' },
    { label: '子女', value: '2' }
  ],
  // 保险工作经历,
  insure_history:  [
    { label: '否', value: '0' },
    { label: '是', value: '1' }
  ],
  // 面试结果,
  interviewResult: [
    { label: '未处理', value: '-1' },
    { label: '转发', value: '0' },
    { label: '未通过', value: '1' },
    { label: '通过', value: '2' },
    { label: '需分公司面', value: '3' }
  ],
  family_Card_type: [
    { label: '身份证', value: '1' },
    { label: '护照', value: '2' },
    { label: '军官证', value: '3' },
    { label: '士兵证', value: '4' },
    { label: '港澳居民往来内地通行证', value: '5' },
    { label: '台湾居民来往大陆通行证', value: '6' },
    { label: '户口本', value: '7' },
    { label: '出生证', value: '8' },
    { label: '港澳居民居住证', value: '10' },
    { label: '台湾居民居住证', value: '11' }
  ],
  familySex: [
    { label: '男', value: '1' },
    { label: '女', value: '2' }
  ],
  step_all_status: [
    {
      value: '1',
      label: '创建简历'
    },
    {
      value: '2',
      label: '性向测试'
    },
    {
      value: '3',
      label: 'COP签到'
    },
    {
      value: '4',
      label: '简历完成'
    },
    {
      value: '5',
      label: '待一面'
    },
    {
      value: '6',
      label: '一面完成'
    },
    {
      value: '7',
      label: '待二面'
    },
    {
      value: '8',
      label: '二面完成'
    },
    {
      value: '9',
      label: '待其他面试'
    },
    {
      value: '10',
      label: '其他面试完成'
    },
    {
      value: '11',
      label: '待机构确认'
    },
    {
      value: '12',
      label: '机构确认完成'
    },
    {
      value: '13',
      label: '待分公司审核'
    },
    {
      value: '14',
      label: '分公司审核完毕'
    },
    {
      value: '15',
      label: '面试调整'
    },
    {
      value: '-2',
      label: '取消面试调整'
    },
    {
      value: '-3',
      label: '取消分公司审核'
    },
    {
      value: '16',
      label: '退回机构管理'
    },
    {
      value: '17',
      label: '培训中'
    },
    {
      value: '18',
      label: '未通过'
    },
    {
      value: '19',
      label: '通过'
    },
    {
      value: '20',
      label: '未审核'
    },
    {
      value: '21',
      label: '审核未通过'
    },
    {
      value: '22',
      label: '审核通过'
    },
    {
      value: '23',
      label: '已录入'
    }
  ],
  interviewerType_status: [
    {
      label: '推荐人主管',
      value: "1"
    },
    {
      label: '内勤面试官',
      value: "2"
    },
  ],
  step_status:[
    {
      label: '一面',
      value: '2'
    },
    {
      label: '二面',
      value: '4'
    },
    {
      label: '其他面试',
      value: '5'
    },
    {
      label: '机构负责人确认',
      value: '6'
    },
  ],
  // 作废原因
  cancel_reason: [
    { label: '资料或信息有误', value: '1' },
    { label: '资料或信息不完整', value: '2' },
    { label: '面试信息有误', value: '3' },
    { label: '面试信息调整', value: '4' },
    { label: '其他', value: '5' }
  ],
  // 退回原因
  return_reason: [
    { label: '资料或信息有误', value: '1' },
    { label: '资料或信息不完整', value: '2' },
    { label: '不满足招募要求', value: '3' },
    { label: '其他', value: '4' }
  ],
  // 招募状态修改-撤销
  revoke_status: [
    { label: '一面作废', value: '2' },
    { label: '二面作废', value: '4' },
    { label: '其他面试作废', value: '5' },
    { label: '分公司审核通过', value: '7' }
  ],
  // 专业背景
  professionalBackground: [
    { label: '保险', value: '保险' },
    { label: '金融',   value: '金融' },
    { label: '管理',   value: '管理' },
    { label: '销售',   value: '销售' },
    { label: '其他',   value: '其他' }
  ],
  exingIdTypes: [
    { label: '居民身份证', value: '1' },
    { label: '护照', value: '2' },
    { label: '军官证', value: '3' },
    { label: '出生证', value: '4' },
    { label: '户口本', value: '5' },
    { label: '士兵证', value: '6' },
    { label: '港澳居民来往内地通行证', value: '7' },
    { label: '台湾居民来往大陆通行证', value: '8' },
    { label: '港澳居民居住证', value: '10' },
    { label: '台湾居民居住证', value: '11' },
    { label: '中国外国人永久居留身份证', value: '12' },
    { label: '中国籍护照（国外永久居留证）', value: '13' },
    { label: '其它', value: '99' }
  ],
  reminderOptions: [
    { label: '无', value: '' },
    { label: '5分钟前', value: '5' },
    { label: '10分钟前', value: '10' },
    { label: '15分钟前', value: '15' },
    { label: '30分钟前', value: '30' },
    { label: '1小时前', value: '60' },
    { label: '2小时前', value: '120' },
    { label: '1天前', value: '1440'},
    { label: '2天前', value: '2880'}
  ]
}


// WEBPACK FOOTER //
// ./src/components/utils/fixOptions.js